import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { viewTypeOptions } from '../../containers/plan-menu/constants'

export const usePlanMenuStore = create(
  persist(
    (set, get) => ({
      // project the rest of this state currently belongs to. Folder
      // navigation, search and page title are per-project: switching
      // projects without resetting them leaks the previous project's
      // folder/search context into the new one.
      currentProjectId: null,
      setCurrentProjectId: (projectId) => {
        if (get().currentProjectId === projectId) return

        set({
          currentProjectId: projectId,
          tileViewFolderHistory: [],
          pageTitle: null,
          planMenuSearch: ''
        })
      },

      pageTitle: null,
      setPageTitle: (pageTitle) => set({ pageTitle }),

      tileViewFolderHistory: [],
      setTileViewFolderHistory: (tileViewCurrentFolder) =>
        set({ tileViewFolderHistory: tileViewCurrentFolder }),

      planMenuSearch: '',
      setPlanMenuSearch: (planMenuSearch) => set({ planMenuSearch }),

      planMenuShowInactive: false,
      setPlanMenuShowInactive: (planMenuShowInactive) =>
        set({ planMenuShowInactive }),

      planMenuPageSize: 15,
      setPlanMenuPageSize: (planMenuPageSize) => set({ planMenuPageSize }),

      // last view the user picked: not tied to a project, it is what the plan
      // menu falls back to when it is reached without a view in the URL
      planMenuViewType: viewTypeOptions.LIST_VIEW,
      setPlanMenuViewType: (planMenuViewType) => set({ planMenuViewType })
    }),

    {
      name: 'plan-menu-store',
      partialize: (state) => ({
        planMenuPageSize: state.planMenuPageSize,
        planMenuViewType: state.planMenuViewType
      })
    }
  )
)
